// extracted by mini-css-extract-plugin
export default {"videoContainer":"QrScanner_videoContainer__PLWfK","videoElement":"QrScanner_videoElement__ymTjI","canvasElement":"QrScanner_canvasElement__B26m8"};